<div>
    <app-vwsa-text text="This site is currently offline or under maintenance, please try again later.">
    </app-vwsa-text>

    <br />
    <app-vwsa-button text="Home" (click)="onHome()"></app-vwsa-button>
</div>